// use with bank-logos-30 directory

export default {
  poalim: 'hapoalim.svg',
  isracard: 'CCIsracard45.png',
  leumicard: 'CCLeumi45.png',
  leumiBank: 'leumi.svg',
  YahavBank: 'Yahav45.png',
  cal: 'CCCal45.png',
  DiscountBank: 'discount.svg',
  discountApi: 'discount.svg',
  massad: 'massad.svg',
  otsar: 'otsar.png',
  benleumi: 'habeinleumi.svg',
  MercantileBank: 'mercantile.png',
  americanexpress: 'CCAMX45.png',
  mizrahi: 'mizrachi.svg',
  egudbank: 'egud.svg',
  ubank: 'ubank.png',
  pagi: 'pagi.png',
  doar: 'doar.svg',
};



// WEBPACK FOOTER //
// ./src/utils/sourcesToLogo.js